import round from "./round";

export default precision => n => {
  const decimal = n - Math.floor(n);
  if (decimal === 0) return n;

  const times = round(decimal / precision, 0);
  return Math.floor(n) + precision * times;
};
